<template>
  <div>已跳转新页面，请在新页面查看</div>
</template>
<script>
import { getbcUrl } from '@/api/wms-stock'
export default {
  data () {
    return {
      id: ''
    }
  },
  created () {
    this.id = this.$route.query.id
    this.getbcUrl()
  },
  methods: {
    getbcUrl () {
      getbcUrl({
        warehouseId: this.id
      })
        .then((res) => {
          // console.log(res, 'res')
          window.open(res)
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style>

</style>
